module.exports = {
      id: "phone-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-0a04d67e7be2467ff8c30ec762f261a0.svg#phone",
      toString: function () {
        return this.url;
      }
    }